import { useState } from 'react';

import { render as renderCustom } from '../entry';

import { client, ClientProvider } from "@magalu/rave/graphql";
import { ConfigProvider } from "@magalu/rave/config/Provider";

// Data Source Configs
import { configs as dataSourceConfigs } from '../datasource/config';
const { cachePolicies = {}, localTypeDefs,  linkMiddlewares = [] } = dataSourceConfigs ;

import clientConfig from '../containers/client-config';


const CustomRender = ({ Component, pageProps }) => {
  return renderCustom({ Component, pageProps });
};

export const withRaveContexts = (children, clientEnvs = {}) => {
  const [configEnvs] = useState({ client: { ...clientConfig, ...clientEnvs } });
  let clientProviderParams = {};

  clientProviderParams = {
    config: {
      ...({
  "configsDir": "config",
  "host": "https://federation.magazineluiza.com.br",
  "timeout": 5000
} || {}),
      ...(configEnvs?.client?.datasource?.graphql || {})
    },
  };
  clientProviderParams['cachePolicies'] = cachePolicies;
  clientProviderParams['localTypeDefs'] = localTypeDefs;
  clientProviderParams['linkMiddlewares'] = linkMiddlewares;
  clientProviderParams['configEnv'] = configEnvs.client;
  return (
    <ClientProvider {...clientProviderParams}>
      <ConfigProvider config={configEnvs}>{children}</ConfigProvider>
    </ClientProvider>
  );
};

export default function CustomApp({ Component, pageProps = {} }) {
  const clientEnvs = pageProps.clientConfig;
  let parsedPageProps = {...pageProps};
    parsedPageProps = {
      ...pageProps,
      ...{
  "manifest": {
    "useTypescript": true,
    "deepLinkHost": "https://m.magazineluiza.com.br",
    "isMiniApp": true
  }
}
    }

    return withRaveContexts(<CustomRender Component={Component} pageProps={parsedPageProps} />, clientEnvs);
};
